import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "album py-5 bg-light"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = { style: {"position":"fixed","width":"100%","left":"0","right":"0","top":"10px"} }
const _hoisted_7 = {
  style: {"padding":"6px 10px","border-radius":"100px"},
  class: "cborder"
}
const _hoisted_8 = {
  style: {"padding":"7px 7px 2px 7px"},
  class: "cborder"
}
const _hoisted_9 = {
  style: {"padding":"6px 10px","border-radius":"100px","margin-left":"auto"},
  class: "cborder"
}
const _hoisted_10 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#settingsmodal"
}
const _hoisted_11 = { style: {"position":"fixed","width":"100%","left":"0","right":"0","bottom":"10px"} }
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-0 col-lg-1 col-xl-2" }, null, -1)
const _hoisted_14 = {
  class: "col-12 col-lg-10 col-xl-8",
  style: {"padding":"0px"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-0 col-lg-1 col-xl-2" }, null, -1)
const _hoisted_18 = {
  class: "modal fade",
  id: "settingsmodal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Impostazioni"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, "Direzione di lettura", -1)
const _hoisted_24 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic radio toggle button group"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  class: "btn btn-outline-primary",
  for: "btnradio1"
}, "Da sinistra a destra", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  class: "btn btn-outline-primary",
  for: "btnradio2"
}, "Da destra a sinistra", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fai = _resolveComponent("fai")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading||_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.loading&&!_ctx.error)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("h5", null, _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      (!_ctx.loading&&!_ctx.error)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "container",
            style: [{'opacity': _ctx.gui ? '1' : '0', 'visibility': _ctx.gui ? 'visible' : 'hidden'}, {"display":"flex","align-items":"center","text-align":"left","transition":"visibility 0.25s, opacity 0.25s linear"}]
          }, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: '/manga/'+this.$route.params.manga
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fai, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("h6", null, _toDisplayString(_ctx.manga.title), 1),
              _createVNode("small", null, _toDisplayString((_ctx.data.volume ? 'Vol.'+_ctx.data.volume+' ' : '') + 'Ch.'+_ctx.data.chapter) + _toDisplayString(_ctx.data.title ? ' - '+_ctx.data.title : ''), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("a", _hoisted_10, [
                _createVNode(_component_fai, {
                  icon: "cog",
                  class: "fa-lg"
                })
              ])
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_11, [
      (!_ctx.loading&&!_ctx.error)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "container",
            style: [{'opacity': _ctx.gui ? '1' : '0', 'visibility': _ctx.gui ? 'visible' : 'hidden'}, {"display":"flex","align-items":"center","transition":"visibility 0.25s, opacity 0.25s linear"}]
          }, [
            (_ctx.readdir=='ltr'&&this.$route.params.id!=_ctx.manga.chapters[0].chapter)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: '/chapter/'+this.$route.params.manga+'/'+_ctx.getChapter(-1),
                  class: "cborder",
                  style: {"padding":"1px 8px","margin-right":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fai, {
                      icon: "chevron-left",
                      class: "fa-lg"
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.readdir=='rtl'&&this.$route.params.id!=_ctx.manga.chapters.slice().pop().chapter)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: '/chapter/'+this.$route.params.manga+'/'+_ctx.getChapter(1),
                  class: "cborder",
                  style: {"padding":"1px 8px","margin-right":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fai, {
                      icon: "chevron-left",
                      class: "fa-lg"
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (!_ctx.data.webtoon)
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 2,
                  type: "range",
                  class: "form-range cborder",
                  min: "0",
                  max: _ctx.data.images.length-1,
                  step: "0",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.readingpage = $event)),
                  style: [{"padding":"10px"}, { 'direction': _ctx.readdir }]
                }, null, 12, ["max"])), [
                  [_vModelText, _ctx.readingpage]
                ])
              : _createCommentVNode("", true),
            (_ctx.readdir=='ltr'&&this.$route.params.id!=_ctx.manga.chapters.slice().pop().chapter)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: '/chapter/'+this.$route.params.manga+'/'+_ctx.getChapter(1),
                  class: "cborder",
                  style: {"padding":"1px 8px","margin-left":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fai, {
                      icon: "chevron-right",
                      class: "fa-lg"
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.readdir=='rtl'&&this.$route.params.id!=_ctx.manga.chapters[0].chapter)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: '/chapter/'+this.$route.params.manga+'/'+_ctx.getChapter(-1),
                  class: "cborder",
                  style: {"padding":"1px 8px","margin-left":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fai, {
                      icon: "chevron-right",
                      class: "fa-lg"
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading&&!_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode("div", null, [
              (!_ctx.data.webtoon)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.images, (page) => {
                      return (_openBlock(), _createBlock("div", {
                        key: page,
                        class: "imgbox",
                        style: { 'height': Math.abs(_ctx.data.images.indexOf(page)-_ctx.readingpage)==0 ? '100vh' : '0px' }
                      }, [
                        _withDirectives(_createVNode("img", {
                          src: _ctx.data.images.indexOf(page)==_ctx.readingpage||_ctx.data.images.indexOf(page)==_ctx.firsttoload||this.loadedimages[this.data.images.indexOf(page)]==1 ? page : '',
                          class: "img-fluid cimage",
                          style: {"cursor":"pointer"},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageclick($event))),
                          onLoad: ($event: any) => (_ctx.afterimageload(page))
                        }, null, 40, ["src", "onLoad"]), [
                          [_vShow, Math.abs(_ctx.data.images.indexOf(page)-_ctx.readingpage)==0]
                        ])
                      ], 4))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.webtoon)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.images, (page) => {
                      return (_openBlock(), _createBlock("div", { key: page }, [
                        (_ctx.data.images.indexOf(page)<=_ctx.loadlimit)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: page,
                              class: "img-fluid",
                              style: {"width":"100%"},
                              onLoad: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadlimit++)),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gui = !_ctx.gui))
                            }, null, 40, ["src"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_17
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _withDirectives(_createVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "btnradio",
                value: "ltr",
                id: "btnradio1",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.readdir = $event)),
                checked: ""
              }, null, 512), [
                [_vModelRadio, _ctx.readdir]
              ]),
              _hoisted_25,
              _withDirectives(_createVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "btnradio",
                value: "rtl",
                id: "btnradio2",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.readdir = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.readdir]
              ]),
              _hoisted_26
            ])
          ])
        ])
      ])
    ])
  ]))
}